<ng-container *ngIf="user; else loader">
  <mat-drawer-container class="mat-drawer-container user-mat-drawer" autosize>
    <mat-drawer #drawer class="sidenav" mode="side" opened="true" disableClose="true">
      <div class="navigation">
        <mat-list class="list">
          <div class="nav-section">
            <h2>Статистика</h2>
            <mat-divider class="section-divider"></mat-divider>
            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./main">
                <span>Общая</span>
              </a>
            </mat-list-item>

            <mat-list-item *ngIf="isGoFast" class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./customization">
                <span>Кастомизация</span>
              </a>
            </mat-list-item>

            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./user-inventory">
                <span>Инвентарь</span>
              </a>
            </mat-list-item>

            <mat-list-item *ngIf="isGoFast" class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./market">
                <span>Маркет</span>
              </a>
            </mat-list-item>
            <!--            *ngIf="isGoFast"-->
            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./referral-campaigns">
                <span>Реферальные кампании</span>
              </a>
            </mat-list-item>

            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./paybacks">
                <span>Отыгрыши</span>
              </a>
            </mat-list-item>

            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']"
                 routerLink="./balance-history">
                <span>Лог баланса</span>
              </a>
            </mat-list-item>

            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./raffles">
                <span>Раффлы</span>
              </a>
            </mat-list-item>

            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./seasons">
                <span>Сезоны</span>
              </a>
            </mat-list-item>

            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']"
                 routerLink="./promo-codes-history">
                <span>История промокодов</span>
              </a>
            </mat-list-item>

            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']"
                 routerLink="./transactions-history"
                 [queryParams]="{limit: 500, source: 'all', keys: ''}">
                <span>Лог операций</span>
              </a>
            </mat-list-item>

            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./refill">
                <span>Пополнения</span>
                <span>
                    {{ user.balanceTransactions.total_refill }}
                  </span>
              </a>
            </mat-list-item>

            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./withdraw">
                <span>Выводы</span>
                <span
                  matTooltip="Завершенных / всего выводов"
                  matTooltipPosition="above"
                >
                  {{ user.balanceTransactions.finished_payouts }} / {{ getTotalPayouts() }}
                </span>
              </a>
            </mat-list-item>

            <mat-list-item *ngIf="!isGoFast" class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./welcome-cases">
                <span>Welcome кейсы</span>
              </a>
            </mat-list-item>

          </div>
          <div class="nav-section security">
            <h2>Безопасность</h2>
            <mat-divider class="section-divider"></mat-divider>
            <mat-list-item class="mat-list">
              <ng-container *ngIf="user.security.ip then ip; else empty"></ng-container>
              <ng-template #ip>
                <a class="list-item link" [routerLink]="['./check/ip', user.security.ip]"
                   [routerLinkActive]="['is-active']">
                  <span class="text-overflow">{{ user.security.ip }}</span>
                  <mat-icon
                    matTooltip="История входов"
                    matTooltipPosition="above"
                    class="icon-inactive"
                    (click)="$event.preventDefault(); openAuthHistory()">history
                  </mat-icon>
                </a>
              </ng-template>
              <ng-template #empty>
                <div class="list-item">
                  <span>IP адрес отсутствует</span>
                  <mat-icon (click)="openAuthHistory()"
                            class="icon-inactive"
                            matTooltip="История входов"
                            matTooltipPosition="above">history
                  </mat-icon>
                </div>
              </ng-template>
            </mat-list-item>

            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./contacts">
                <span>Контакты</span>
              </a>
            </mat-list-item>

            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./restrictions">
                <span>Ограничения</span>
              </a>
            </mat-list-item>

          </div>
          <div class="nav-section">
            <h2>Steam</h2>
            <mat-divider class="section-divider"></mat-divider>
            <mat-list-item class="mat-list">
              <a class="list-item link" [routerLinkActive]="['is-active']" href="{{user.steamMarket.profile}}"
                 target="_blank">
                <span>Открыть в Steam</span>
                <mat-icon class="material-icons-outlined icon-inactive">launch</mat-icon>
              </a>
            </mat-list-item>

            <mat-list-item>
              <a class="list-item link" [routerLinkActive]="['is-active']" href="{{user.steamMarket.trade}}"
                 target="_blank">
                <span>Открыть Trade</span>
                <mat-icon class="material-icons-outlined icon-inactive">launch</mat-icon>
              </a>
            </mat-list-item>

          </div>
          <ng-container *ngIf="isGoFast">
            <div class="nav-section bonuses">
              <h2>Бонусы</h2>
              <mat-divider class="section-divider"></mat-divider>

              <mat-list-item class="mat-list faucet">
                <div class="list-item">
                  <span>Кран</span>
                  <div class="icons">
                    <span>{{ user.bonuses.faucet }}</span>
                    <mat-icon class="reset icon-inactive"
                              matTooltip="Сбросить кран до 100"
                              matTooltipPosition="above"
                              (click)="resetFaucet()">replay
                    </mat-icon>
                  </div>
                </div>
              </mat-list-item>

              <mat-list-item class="mat-list">
                <a class="list-item link" routerLink="./cashback-history"
                   [routerLinkActive]="['is-active']"
                   (click)="scrollToTop()">
                  <span>Cashback</span>
                  <span matTooltip="{{user.bonuses.cashback.coinsAmount | fastCoinsToDollar}}"
                        matTooltipPosition="above"
                        [matTooltipDisabled]="!isGoFast">{{ user.bonuses.cashback.coinsAmount / 100 }}</span>
                </a>
              </mat-list-item>

              <mat-list-item class="mat-list">
                <a class="list-item link" routerLink="./xp-history"
                   [routerLinkActive]="['is-active']"
                   (click)="scrollToTop()">
                  <span>XP</span>
                  <span>{{ user.bonuses.xp }}</span>
                </a>
              </mat-list-item>

              <mat-list-item class="mat-list">
                <div class="list-item">
                  <span>Реф. монет </span>
                  <span>{{ user.bonuses.refCoins }}</span>
                </div>
              </mat-list-item>

              <mat-list-item class="mat-list">
                <a class="list-item link" (click)="scrollToTop()" [routerLinkActive]="['is-active']"
                   routerLink="./free-cases">
                  <span>Free cases</span>
                </a>
              </mat-list-item>

              <mat-list-item class="mat-list">
                <div class="list-item">
                  <span>Кейсы:</span>
                  <div class="cases">
                    <span class="orange-border">{{ user.bonuses.cases.orangeCases }}</span>
                    <span class="silver-border">{{ user.bonuses.cases.silverCases }}</span>
                    <span class="blue-border">{{ user.bonuses.cases.blueCases }}</span>
                  </div>
                </div>
              </mat-list-item>

              <mat-list-item class="mat-list">
                <div class="list-item">
                  <span>Билеты:</span>
                  <div class="tickets">
                    <span class="orange-border">{{ user.bonuses.tickets.orange || 0 }}</span>
                    <span class="green-border">{{ user.bonuses.tickets.green || 0 }}</span>
                    <span class="blue-border">{{ user.bonuses.tickets.blue || 0 }}</span>
                  </div>
                </div>
              </mat-list-item>

              <mat-list-item *ngIf="canAccessVip" class="mat-list">
                <a class="list-item link" [routerLinkActive]="['is-active']" routerLink="./vip">
                  <span>VIP</span>
                  <mat-icon class="material-icons-outlined icon-inactive" style="font-size: 18px;">stars</mat-icon>
                </a>
              </mat-list-item>
            </div>
          </ng-container>
        </mat-list>
      </div>

    </mat-drawer>

    <div class="sidenav-content">
      <div class="content-wrapper">
        <ng-container *ngIf="user.security.blockStore
        || user.security.blockUser
        || user.security.xpLock
        || user.security.isTrader
        || user.security.permLock?.length
        || user.security.promotionLock
        || !!user.security.storeWithdrawLimit
        || (hasRefundIssue$ | async)">
          <div *ngIf="!isHideWarning" class="container warnings">
            <div class="warn-content">
              <mat-icon class="sign">report</mat-icon>
              <span class="warn-text">На аккаунте есть ограничения</span>
              <button class="btn btn-sm watch-warn-btn" routerLink="./restrictions">смотреть</button>
            </div>
            <mat-icon class="close" (click)="hideWarnings()">close</mat-icon>
          </div>
        </ng-container>

        <app-user-header [user]="user"
                         [isGoFast]="isGoFast">
        </app-user-header>
        <router-outlet></router-outlet>
      </div>
    </div>

  </mat-drawer-container>
</ng-container>
<ng-template #loader>
  <div class="spinner-container">
    <mat-progress-spinner
      [diameter]="50"
      color="primary"
      mode="indeterminate">
    </mat-progress-spinner>
  </div>
</ng-template>
